export default __webpack_public_path__ + "static/media/hamburger.0ef39251.svg";